import React from 'react'
import clsx from 'clsx'

export default function Card({ children, className }) {
  return (
    <div
      className={clsx('bg-white rounded-xl shadow-minex overflow-hidden fancy-bounce py-2 relative z-30', className)}
    >
      {children}
    </div>
  )
}
